module.exports = __webpack_public_path__ + "static/Hero-Article-Biometric-Screenings-b347c8496296f0cc4fe7e740b6aa34ff.png";